var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13A9B2",
    fillRule: "evenodd",
    d: "M24 46C12 40.654 6 35.32 6 30V10c0-1.535.59-1.892 2.22-2.88A45.786 45.786 0 0 0 10 6c.324-.216 7.126-4 14-4 5.99 0 11 2 14 4 .697.465 1.286.822 1.78 1.12C41.41 8.109 42 8.466 42 10c.04.434.02 9.674.008 15.59C42.003 27.606 42 29.236 42 30c0 5.333-6 10.667-18 16Zm14-16 .004-2.49.008-3.907.006-3.383c.007-4.465.005-8.296.001-9.481l-.275-.17c-.646-.402-1.49-.925-1.963-1.24C32.83 7.358 28.521 6 24 6c-4.324 0-9.943 2.103-11.781 3.328-.474.316-1.317.839-1.963 1.24l-.256.159V30c0 3.017 4.458 7.138 14.002 11.604C33.544 37.148 38 33.029 38 30Zm-7.414-13.414L22 25.172l-4.586-4.586-2.828 2.828L22 30.83l11.414-11.415-2.828-2.828Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.6463e7e90110d1fe46c05924cc342209.svg";
export { ForwardRef as ReactComponent };